<template>
    <div>
        <span v-if="validation" style="color: red; font-size: 20px; padding-right: 3px;">*</span>
        <span style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:rgba(51,51,51,1);">{{lable}}</span>
        <VsSelect 
            style="display: inline-block;background:rgba(255,255,255,1);border-radius:3px;"
			:disabled="disabled"
            :lablewidth="lablewidth" 
            :width="width" 
            :classtype="classtype" 
            :keys="['ZGMC','ZGID']"
            v-model="select.value"
            :loopdata="select.droplist"
            @input="fnInputAct"
            @on-enter="fnEnterpressAct"
            @click="fnInputSelect"
            @inputserch="fnInputSelect"
            :requiremore="select.requiremore"
            @require="fnInputSelect"
            @on-confirm="fnSelectConfirm">
        </VsSelect>
    </div>
</template>

<script>
	export default{
		props:{
			disabled:{},
			loopdata:{},
			keys:{},
			lablewidth:{},
			width:{},
			lable:{},
			classtype:{},
			selectValue:{},
			returnkey:{},
			validation:{},
			selectText:{},
		},
		model: {
			prop: 'selectValue',  
			event: 'on-model'
		},
		data(){
			return{
				select:{
					value:this.selectText,
					PageNo:'1',
					PageSize:'50',
					requiremore:true,
					droplist:[],
                }
                
			}
		},
	
		methods:{
			fnInputAct($event){
				//console.log('fnInputAct:'+this.selectValue)
				this.select.droplist = []
				this.select.PageNo = 1
				this.select.requiremore = true
				this.fnSelectConfirm()
				this.$emit('input',$event)
				if(this.selectValue){
                    this.$emit('on-model',"")
                }
            },
            
			fnInputSelect(){
				//console.log('fnInputSelect:'+this.selectValue)
				this.select.value = ''
				if(this.select.requiremore){
					let params = this.$fun.GetUserConstant()
                        params.Operators = '模糊查询'
                        params.PageSize = this.select.PageSize
                        params.PageNo = this.select.PageNo
                        params.Values = this.select.value
					this.$Api.ErpYGinfoGetbyPromiss(params).then((res)=>{
						// console.log(res)
                        if(res.data.data.page.length > 0){
							//this.select.droplist = [];
							let dtemp=[];
							res.data.data.page.forEach(x=>{
							if(x.IsDelete==0)
							{
								dtemp.push(x);
							}
							});
							if(dtemp.length>0)
							{
							  this.select.droplist = this.select.droplist.concat(dtemp);				
							}
							this.select.PageNo++
						}else{
							this.select.requiremore = false
							this.select.PageNo=1
						}
					})
				}
            },
            
			fnSelectConfirm(data){
				//console.log('fnSelectConfirm:'+ JSON.stringify(data));
				if(data){
					if(this.returnkey){
						this.$emit('on-model',data[this.returnkey])
						this.$emit('on-select',data)
					}else{
						this.$emit('on-select',data)
					}
				}else{
					this.$emit('on-select',"")
					this.$emit('on-model','')
				}
            },
            
			fnEnterpressAct($event){
				this.$emit('on-enter',$event)
            }
            


		}
	}
</script>
